<template>
  <layout-element-width-component
    :class="$style.root"
    :scale="scale"
    :orientation="imageOrientation"
    :style="cssColors"
    ref="rootTarget"
    v-animated-underline-mouse-events
  >
    <i18n-link
      :to="{ name: 'editions-slug-index-about', params: { slug: data?.slug } }"
      :class="$style.link"
    >
      <core-image-component
        v-if="image?.formats"
        :image="image"
        :class="$style.image"
      />

      <div :class="$style.information">
        <div :class="$style.title">
          <shared-edition-animated-title-component
            :title="data?.title?.trim()"
            :active="rootTargetIsVisibleDebounced"
            :class="$style.titleInner"
          />{{ data?.titleAnnotation ? `, ${data?.titleAnnotation?.trim()?.toLowerCase()}` : null }}
        </div>

        <core-date-time-range-component
          v-if="!data?.hideDates"
          :date-start="data?.dateStart"
          :date-end="data?.dateEnd"
          :class="$style.dates"
        />

        <div
          v-if="richText"
          v-html="richText"
          :class="$style.richText"
        />
      </div>
    </i18n-link>
  </layout-element-width-component>
</template>

<script setup>
const rootTarget = ref(null)

const rootTargetIsVisible = useElementVisibility(rootTarget)
const rootTargetIsVisibleDebounced = refDebounced(rootTargetIsVisible, 500)

const props = defineProps({
  data: Object,
  scale: {
    type: Number,
    default: 1
  },
  isCurrent: {
    type: Boolean,
    default: false
  },
})

const richText = props?.data?.richText ? baseTruncateString(props?.data?.richText, 30) : null

const image = props?.data?.image

const colors = props?.data?.colors
const cssColors = getCssColors(colors)

const imageOrientation = image?.width == image?.height ? 'square' : image?.width > image?.height ? 'landscape' : 'portrait'
</script>

<style module>
.root {
  background-color: var(--color--background);
  color: var(--color--primary);
  padding: var(--unit--vertical) var(--unit--horizontal);
}

.root:focus-within .image {
  outline: var(--outline--focus);
}

.link {
  composes: reset-link from global;
}

.information {
  composes: font-size-small from global;
  margin-left: auto;
  margin-right: auto;

  margin-top: var(--unit--vertical);
}

.title {
  composes: font-size-medium from global;
}

.titleInner {
  composes: animated-underline from global;
}

.dates {
  color: var(--color--secondary);
  display: inline-block;
}

.richText {
  composes: font-size-small from global;

  margin-top: calc(var(--padding--element--top) - var(--font-medium--compensation--lh));
}
</style>
